export default "__VITE_ASSET__BEVnQD8G__"